import React, { useEffect, useState } from "react";
import styles from "./CheckoutPage.module.scss";
import className from "classnames/bind";
import useCheckoutProductStore from "../../stores/CheckoutProduct/useCheckoutProductStore";
import { useLanguageStore } from "../../stores/Language/useLanguageStore";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getAllProducts } from "../../services/Products/ProductServices";
import { Trash2, ArrowLeft } from "lucide-react";
import { transformProductRecomend } from "../../utils/transformProductRecomend";
import ProductSlideshow from "../../components/ProductSlideshow/ProductSlideshow";
import useTranslations from "../../hooks/useTranslations";
import Images from "../../asset/images";
import { translateProductName } from "../../utils/translateProductName";

const cx = className.bind(styles);

const CheckoutPage = () => {
  const [productRecomend, setProductRecomend] = useState([]);
  const translations = useTranslations();
  const navigate = useNavigate();
  const location = useLocation();
  const [zoomImage, setZoomImage] = useState(null);

  const {
    items: checkoutProducts,
    removeCheckoutItem,
    subtotal,
  } = useCheckoutProductStore();
  const { formatPrice } = useLanguageStore();

  // Clear checkout items if no items and not coming from order-info
  useEffect(() => {
    // If there are no checkout items and user didn't come from order-info, redirect to home
    if (checkoutProducts.length === 0 && !location.state?.fromOrderInfo) {
      navigate("/", { replace: true });
    }
  }, [checkoutProducts, navigate, location.state]);

  useEffect(() => {
    const fetchProductRecommend = async () => {
      let res = await getAllProducts();

      if (res && res.length > 0) {
        const transformed = res.map(transformProductRecomend);
        setProductRecomend(transformed);
      }
    };
    fetchProductRecommend();
  }, []);


  return (
    <div className={cx("wrapper")}>
      <div className={cx("content")}>
        <div className={cx("product-list")}>
          <div className={cx("checkout-header")}>
            <h1>{translations?.OrderReview?.title || "Order Review"}</h1>
          </div>
          {checkoutProducts &&
            checkoutProducts.map((item) => (
              <div
                key={item.local_key || item.cart_item_key || item.id}
                className={cx("product-item")}
              >
                <img src={item.image} alt={item.name} />
                <div className={cx("product")}>
                  <div className={cx("product-info")}>
                    <div className={cx("info")}>
                      <h3>{translateProductName(item.name)}</h3>
                      <span className={cx("option")}>{item.selected}</span>
                      <p>
                        {translations?.OrderReview?.quantity || "Quantity"}:{" "}
                        {item.quantity}
                      </p>
                    </div>
                    {/* Hiển thị quà tặng chỉ khi có quà (có thể thêm điều kiện item.hasGift) */}
                    {item.gift && item.selected !== "No Box" && (
                      <div className={cx("gifts")}>
                        <h6>
                          {translations?.OrderReview?.free_gift ||
                            "Quà tặng đi kèm"}
                        </h6>
                        <div className={cx("images")}>
                          <img
                            src={item.gift?.srcGift || Images.ErrorImage}
                            alt="Gift box"
                            title="Hộp quà tặng cao cấp"
                            onClick={() =>
                              setZoomImage(
                                item.gift?.srcGift || Images.ErrorImage
                              )
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </div>
                    )}
                    {zoomImage && (
                      <div
                        className={cx("zoom-modal")}
                        onClick={() => setZoomImage(null)}
                      >
                        <img
                          src={zoomImage}
                          alt="Zoomed gift"
                          className={cx("zoom-image")}
                        />
                      </div>
                    )}
                  </div>
                  <div className={cx("product-price")}>
                    <p className={cx("price")}>{formatPrice(item.price)}</p>
                    <button
                      onClick={() => removeCheckoutItem(item.cart_item_key)}
                      className={cx("remove-btn")}
                    >
                      <Trash2 />
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </div>

        <div className={cx("order-summary")}>
          <h2>{translations?.OrderReview?.order_total || "Order Total"}</h2>
          <div className={cx("summary-item")}>
            {checkoutProducts.map((item, index) => (
              <div
                key={item.local_key || item.cart_item_key || item.id}
                className={cx("item-row")}
              >
                <span>
                  {index + 1} {translateProductName(item.name)}
                </span>
                <span>{formatPrice(item.price)}</span>
              </div>
            ))}
          </div>
          <div className={cx("subtotal")}>
            <span>{translations?.OrderReview?.subtotal || "Subtotal"}</span>
            <span>{formatPrice(subtotal)} </span>
          </div>
          <div className={cx("checkout-actions")}>
            <Link to="/checkout/order-info" className={cx("checkout-btn")}>
              {translations?.OrderReview?.purchase || "PURCHASE"}
            </Link>
          </div>
        </div>
        {/* </div> */}
      </div>
      <div className={cx("recommend")}>
        <h2 className={cx("recommend-header")}>
          {translations?.productDetail?.recommended_for_you ||
            "Add more to your bag"}
        </h2>
        <div className={cx("recommend-products")}>
          <ProductSlideshow
            items={productRecomend}
            column={true}
            showBtn={false}
            itemsPerPage={4}
            showHeader={false}
          />
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;
